const lv = {
  // ============================================================
  // COMMON — Kopīgs visai lietojumprogrammai
  // ============================================================
  common: {
    loading: 'Ielāde...',
    error: 'Kļūda',
    save: 'Saglabāt',
    cancel: 'Atcelt',
    delete: 'Dzēst',
    edit: 'Rediģēt',
    create: 'Izveidot',
    add: 'Pievienot',
    remove: 'Noņemt',
    close: 'Aizvērt',
    confirm: 'Apstiprināt',
    apply: 'Lietot',
    reset: 'Atiestatīt',
    search: 'Meklēt',
    filter: 'Filtrēt',
    clear: 'Notīrīt',
    back: 'Atpakaļ',
    next: 'Tālāk',
    previous: 'Iepriekšējais',
    submit: 'Iesniegt',
    update: 'Atjaunināt',
    refresh: 'Atsvaidzināt',
    export: 'Eksportēt',
    import: 'Importēt',
    download: 'Lejupielādēt',
    upload: 'Augšupielādēt',
    print: 'Drukāt',
    copy: 'Kopēt',
    yes: 'Jā',
    no: 'Nē',
    ok: 'OK',
    done: 'Gatavs',
    select: 'Izvēlēties',
    selectAll: 'Izvēlēties visus',
    deselectAll: 'Noņemt izvēli',
    noResults: 'Rezultāti nav atrasti',
    noData: 'Dati nav pieejami',
    required: 'Obligāts',
    optional: 'Neobligāts',
    actions: 'Darbības',
    details: 'Detaļas',
    overview: 'Pārskats',
    summary: 'Kopsavilkums',
    total: 'Kopā',
    all: 'Visi',
    none: 'Nav',
    name: 'Nosaukums',
    type: 'Tips',
    status: 'Statuss',
    date: 'Datums',
    time: 'Laiks',
    description: 'Apraksts',
    notes: 'Piezīmes',
    comments: 'Komentāri',
    category: 'Kategorija',
    priority: 'Prioritāte',
    nation: 'Valsts',
    country: 'Valsts',
    email: 'E-pasts',
    phone: 'Tālrunis',
    address: 'Adrese',
    location: 'Atrašanās vieta',
    coordinates: 'Koordinātas',
    latitude: 'Platuma grāds',
    longitude: 'Garuma grāds',
    from: 'No',
    to: 'Līdz',
    createdAt: 'Izveidots',
    updatedAt: 'Atjaunināts',
    createdBy: 'Izveidoja',
    modifiedBy: 'Mainīja',
    active: 'Aktīvs',
    inactive: 'Neaktīvs',
    enabled: 'Iespējots',
    disabled: 'Atspējots',
    showing: 'Tiek rādīti',
    of: 'no',
    page: 'Lapa',
    perPage: 'lapā',
    rows: 'rindas',
    items: 'ieraksti',
    results: 'rezultāti',
    sortBy: 'Kārtot pēc',
    ascending: 'Augoši',
    descending: 'Dilstoši',
    viewAll: 'Skatīt visus',
    viewDetails: 'Skatīt detaļas',
    goBack: 'Atgriezties',
    learnMore: 'Uzzināt vairāk',
    seeMore: 'Skatīt vairāk',
    showMore: 'Rādīt vairāk',
    showLess: 'Rādīt mazāk',
    expandAll: 'Izvērst visus',
    collapseAll: 'Sakļaut visus',
    copied: 'Nokopēts!',
    saved: 'Saglabāts!',
    deleted: 'Dzēsts!',
    updated: 'Atjaunināts!',
    created: 'Izveidots!',
    success: 'Veiksmīgi',
    warning: 'Brīdinājums',
    info: 'Informācija',
    danger: 'Bīstami',
    unknown: 'Nezināms',
    notAvailable: 'Nav pieejams',
    never: 'Nekad',
    today: 'Šodien',
    yesterday: 'Vakar',
    tomorrow: 'Rīt',
    now: 'Tagad',
    ago: 'pirms',
    justNow: 'tikko',
    minutesAgo: 'pirms {{count}}min',
    hoursAgo: 'pirms {{count}}st',
    daysAgo: 'pirms {{count}}d',
    monthsAgo: 'pirms {{count}}mēn',
    id: 'ID',
    version: 'Versija',
    language: 'Valoda',
    theme: 'Tēma',
    darkMode: 'Tumšais režīms',
    lightMode: 'Gaišais režīms',
    failedToLoad: 'Neizdevās ielādēt datus',
    failedToSave: 'Neizdevās saglabāt',
    failedToDelete: 'Neizdevās dzēst',
    failedToUpdate: 'Neizdevās atjaunināt',
    confirmDelete: 'Vai tiešām vēlaties to dzēst?',
    confirmAction: 'Vai esat pārliecināts?',
    unsavedChanges: 'Jums ir nesaglabātas izmaiņas. Vai tiešām vēlaties aiziet?',
    pageNotFound: '404 — Lapa nav atrasta',
    pageNotFoundDesc: 'Meklētā lapa neeksistē.',
    backToDashboard: 'Atpakaļ uz vadības paneli',
    characters: 'rakstzīmes',
    maxCharacters: 'Maksimāli {{max}} rakstzīmes',
    remaining: '{{count}} atlikuši',
    selected: '{{count}} izvēlēti',
    of_total: '{{count}} no {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Galvene, sānjosla, izvēlnes
  // ============================================================
  nav: {
    dashboard: 'Vadības panelis',
    requests: 'Pieprasījumi',
    transports: 'Transporti',
    myPatients: 'Mani pacienti',
    statistics: 'Statistika',
    flow: 'Plūsma',
    resources: 'Resources',
    exercise: 'Mācības',
    administration: 'Administrācija',
    map: 'Karte',
    info: 'Informācija',
    users: 'Lietotāji',
    assets: 'Līdzekļi',
    hubs: 'Mezglu punkti',
    treatmentFacilities: 'Ārstniecības iestādes',
    patientImport: 'Pacientu imports',
    assetTemplates: 'Līdzekļu veidnes',
    dayTemplates: 'Dienas veidnes',
    announcementTicker: 'Paziņojumu josla',
    exerciseStatistics: 'Mācību statistika',
    settings: 'Iestatījumi',
    auditLog: 'Audita žurnāls',
    exerciseControl: 'Mācību vadība',
    dataSync: 'Datu sinhronizācija',
    documentation: 'Dokumentācija',
    support: 'Atbalsts',
    about: 'Par sistēmu',
    assetContracts: 'Asset Contracts',
    notifications: 'Paziņojumi',
    schedules: 'Grafiki',
    capacityPlanning: 'Kapacitātes plānošana',
    transportPlanning: 'Transporta plānošana',
    transportBooking: 'Transporta rezervēšana',
    flowDiagram: 'Plūsmas diagramma',
    changePassword: 'Mainīt paroli',
    missions: 'Misijas',
    startPoints: 'Sākuma punkti',
    hospital: 'Slimnīca',
  },

  // ============================================================
  // AUTH — Pieteikšanās, parole, sesija
  // ============================================================
  auth: {
    login: 'Pieteikties',
    logout: 'Izrakstīties',
    logoutNow: 'Izrakstīties tagad',
    loggingIn: 'Pieteikšanās...',
    loginFailed: 'Pieteikšanās neizdevās',
    email: 'E-pasts',
    password: 'Parole',
    username: 'Lietotājvārds',
    enterEmail: 'Ievadiet savu e-pasta adresi',
    enterPassword: 'Ievadiet savu paroli',
    enterUsername: 'Ievadiet savu lietotājvārdu',
    forgotPassword: 'Aizmirsāt paroli?',
    forgotPasswordTitle: 'Aizmirsta parole',
    forgotPasswordDesc: 'Ievadiet savu lietotājvārdu un e-pasta adresi. Ja abi sakrīt, administratori tiks informēti par jūsu paroles atiestatīšanu.',
    requestPasswordReset: 'Pieprasīt paroles atiestatīšanu',
    sending: 'Sūtīšana...',
    backToLogin: 'Atpakaļ uz pieteikšanos',
    pleaseWait: 'Lūdzu, uzgaidiet pirms mēģināt vēlreiz.',
    requestFailed: 'Pieprasījums neizdevās',
    credentialsMatch: 'Ja dati sakrīt, administratori ir informēti.',
    forAccess: 'Lai piekļūtu, lūdzu, sazinieties ar sistēmas administratoru.',
    changePassword: 'Mainīt paroli',
    currentPassword: 'Pašreizējā parole',
    newPassword: 'Jaunā parole',
    confirmPassword: 'Apstiprināt paroli',
    passwordChanged: 'Parole veiksmīgi nomainīta',
    passwordMismatch: 'Paroles nesakrīt',
    passwordTooShort: 'Parolei jābūt vismaz 8 rakstzīmēm',
    changingPassword: 'Mainīšana...',
    mustChangePassword: 'Pirms turpināšanas jums jānomaina parole.',
    sessionExpiring: 'Sesija beidzas',
    sessionExpireText: 'Jūsu sesija beigsies pēc <strong>{{time}}</strong>. Lūdzu, saglabājiet savu darbu un pieteikieties atkārtoti, lai turpinātu.',
    dismiss: 'Noraidīt',
    switchNation: 'Mainīt valsti',
    returnTo: 'Atgriezties uz {{nation}}',
    viewingAs: 'Jūs skatāt kā',
    loggedInAs: 'pieteicies kā {{nation}}',
    trainingMode: 'TIKAI APMĀCĪBU NOLŪKIEM',
    dedication: 'Veidots ar mīlestību un profesionālu centību',
  },

  // ============================================================
  // ROLES — Lietotāju lomas un apzīmējumi
  // ============================================================
  roles: {
    admin: 'Sistēmas administrators',
    excon: 'Mācību vadītājs',
    eu: 'ES koordinators',
    planner: 'Plānotājs',
    hub: 'Mezgla pārvaldnieks',
    nation: 'Valsts',
    readOnly: 'Tikai lasīšana',
    systemAdmin: 'Sistēmas administrators',
    transportPlanner: 'Transporta plānotājs',
    systemRoles: 'Sistēmas lomas',
  },

  // ============================================================
  // STATUS — Pieprasījumu, piedāvājumu, misiju statusi
  // ============================================================
  status: {
    draft: 'Melnraksts',
    underReview: 'Pārskatīšanā',
    published: 'Publicēts',
    underSelection: 'Atlasē',
    accepted: 'Pieņemts',
    planned: 'Plānots',
    inTransit: 'Ceļā',
    completed: 'Pabeigts',
    closed: 'Slēgts',
    withdrawn: 'Atsaukts',
    pending: 'Gaidīšanā',
    rejected: 'Noraidīts',
    cancelled: 'Atcelts',
    active: 'Aktīvs',
    inactive: 'Neaktīvs',
    review: 'Pārskatīšana',
    selection: 'Atlase',
    transit: 'Tranzīts',
  },

  // ============================================================
  // CATEGORIES — Pieprasījumu kategorijas
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personāls',
    material: 'Materiāli',
    equipment: 'Aprīkojums',
    other: 'Cits',
    news: 'Ziņas',
  },

  // ============================================================
  // URGENCY — Steidzamības līmeņi
  // ============================================================
  urgency: {
    routine: 'Ikdienas',
    priority: 'Prioritārs',
    urgent: 'Steidzams',
    immediate: 'Neatliekams',
  },

  // ============================================================
  // ASSETS — Transportlīdzekļu tipi
  // ============================================================
  assetTypes: {
    train: 'Vilciens',
    ship: 'Kuģis',
    aircraft: 'Lidmašīna',
    bus: 'Autobuss',
    ambulance: 'Ātrā palīdzība',
    drone: 'Drons',
    helicopter: 'Helikopters',
    ferry: 'Prāmis',
    other: 'Cits',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Vadības panelis',
    goodMorning: 'Labrīt',
    goodAfternoon: 'Labdien',
    goodEvening: 'Labvakar',
    lastLogin: 'Pēdējā pieteikšanās',
    infrastructure: 'Infrastruktūra',
    transportAssets: 'Transportlīdzekļi',
    treatmentFacilities: 'Ārstniecības iestādes',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Pieprasījumu statistika',
    viewAllRequests: 'Skatīt visus pieprasījumus',
    availableAssets: 'Pieejamie līdzekļi',
    seated: 'Sēdvietas',
    lying: 'Guļvietas',
    intensive: 'Intensīvā aprūpe',
    notifications: 'Paziņojumi',
    markAllRead: 'Atzīmēt visus kā izlasītus',
    noNotifications: 'Paziņojumu nav',
    notifiedWhenActivity: 'Jūs tiksiet informēts, kad parādīsies jauna aktivitāte',
    viewDetailsBtn: 'Skatīt detaļas',
    nationUsers: 'Valstu lietotāji',
    user: 'Lietotājs',
    roles: 'Lomas',
    noUsersFound: 'Lietotāji nav atrasti',
    participatingNations: 'Dalībvalstis',
    exerciseDisclaimer: 'Šī sistēma ir paredzēta tikai mācību vajadzībām. Ievadiet tikai simulētus mācību datus. Darba plūsmas ir pielāgotas mācību scenārijam un var atšķirties no reālajām procedūrām. IT drošības un datu aizsardzības noteikumi paliek pilnībā piemērojami.',
    notConfigured: 'Nav konfigurēts',
    requestCount: '{{count}} pieprasījums(-i)',
    clickToView: 'Noklikšķiniet, lai skatītu',
    systemAdministration: 'Sistēmas administrācija',
    exerciseControlTitle: 'Mācību vadība',
    euCoordination: 'ES koordinācija',
    transportPlanningTitle: 'Transporta plānošana',
    hubManagement: 'Mezglu pārvaldība',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Jauns pieprasījums',
    myDrafts: 'Mani melnraksti',
    pendingReview: 'Gaida pārskatīšanu',
    activeTransports: 'Aktīvie transporti',
    myPatients: 'Mani pacienti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Pieprasījumi',
    newRequest: 'Jauns pieprasījums',
    createRequest: 'Izveidot pieprasījumu',
    editRequest: 'Rediģēt pieprasījumu',
    requestDetail: 'Pieprasījuma detaļas',
    requestId: 'Pieprasījuma ID',
    fromNation: 'No valsts',
    toNation: 'Valstij',
    requestingNation: 'Pieprasītāja valsts',
    receivingNation: 'Saņēmēja valsts',
    category: 'Kategorija',
    urgency: 'Steidzamība',
    status: 'Statuss',
    patients: 'Pacienti',
    patientCount: 'Pacientu skaits',
    offers: 'Piedāvājumi',
    offerCount: 'Piedāvājumu skaits',
    created: 'Izveidots',
    updated: 'Atjaunināts',
    submittedBy: 'Iesniedzis',
    reviewedBy: 'Pārskatījis',
    description: 'Apraksts',
    medicalDetails: 'Medicīniskā informācija',
    transportDetails: 'Transporta informācija',
    additionalInfo: 'Papildu informācija',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Izbraukšanas vieta',
    arrivalPoint: 'Ierašanās vieta',
    estimatedDeparture: 'Plānotā izbraukšana',
    estimatedArrival: 'Plānotā ierašanās',
    submitForReview: 'Iesniegt pārskatīšanai',
    publish: 'Publicēt',
    startSelection: 'Sākt atlasi',
    acceptOffer: 'Pieņemt piedāvājumu',
    markInTransit: 'Atzīmēt kā ceļā',
    markCompleted: 'Atzīmēt kā pabeigtu',
    closeRequest: 'Slēgt pieprasījumu',
    withdrawRequest: 'Atsaukt pieprasījumu',
    withdraw: 'Atsaukt',
    revertToDraft: 'Atgriezt uz melnrakstu',
    deleteRequest: 'Dzēst pieprasījumu',
    duplicateRequest: 'Dublēt pieprasījumu',
    createFollowUp: 'Izveidot konsolidētu pieprasījumu',
    followUpRequest: 'Konsolidēts pieprasījums',
    parentRequest: 'Sākotnējais pieprasījums',
    childRequests: 'Konsolidēti pieprasījumi',
    noRequests: 'Pieprasījumi nav atrasti',
    noOffers: 'Piedāvājumu vēl nav',
    addPatient: 'Pievienot pacientu',
    removePatient: 'Noņemt pacientu',
    patientDetails: 'Pacienta informācija',
    contactPerson: 'Kontaktpersona',
    contactPhone: 'Kontakttālrunis',
    contactEmail: 'Kontakta e-pasts',
    specialRequirements: 'Īpašās prasības',
    medicalEquipment: 'Medicīniskais aprīkojums',
    accompaniment: 'Pavadoņi',
    timeline: 'Laika grafiks',
    history: 'Vēsture',
    addComment: 'Pievienot komentāru',
    writeComment: 'Rakstiet komentāru...',
    postComment: 'Publicēt komentāru',
    posting: 'Publicēšana...',
    noComments: 'Komentāru vēl nav',
    coverageBar: 'Segums',
    covered: 'segts',
    uncovered: 'nesegts',
    filterByStatus: 'Filtrēt pēc statusa',
    filterByCategory: 'Filtrēt pēc kategorijas',
    filterByNation: 'Filtrēt pēc valsts',
    searchRequests: 'Meklēt pieprasījumus...',
    confirmWithdraw: 'Vai tiešām vēlaties atsaukt šo pieprasījumu?',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo pieprasījumu?',
    confirmPublish: 'Vai tiešām vēlaties publicēt šo pieprasījumu? Tas būs redzams visām valstīm.',
    confirmStartSelection: 'Vai tiešām vēlaties sākt atlasi? Valstis varēs iesniegt piedāvājumus.',
    warningStartSelection: 'Atlases sākšana padarīs šo pieprasījumu redzamu visām dalībvalstīm. Tās varēs iesniegt piedāvājumus par šī pieprasījuma pacientiem. Šo darbību nevar atsaukt.',
    warningMakeOffer: 'Iesniedzot šo piedāvājumu, jūs apņematies, ka jūsu valsts nodrošinās piedāvāto palīdzību. Šī darbība paziņos pieprasītājai valstij un mācību vadībai.',
    saveDraft: 'Saglabāt melnrakstu',
    saving: 'Saglabāšana...',
    saveAndSubmit: 'Saglabāt un iesniegt',
    step: 'Solis {{number}}',
    generalInfo: 'Vispārīgā informācija',
    patientInfo: 'Pacienta informācija',
    logisticsInfo: 'Loģistikas informācija',
    reviewSubmit: 'Pārskatīšana un iesniegšana',
    requestTitle: 'Pieprasījuma nosaukums',
    requestDescription: 'Pieprasījuma apraksts',
    numberOfPatients: 'Pacientu skaits',
    typeOfAssistance: 'Palīdzības veids',
    medicalTreatment: 'Medicīniskā ārstēšana',
    transportAssistance: 'Transporta palīdzība',
    both: 'Abi',
    treatmentOnly: 'Tikai ārstēšana',
    transportOnly: 'Tikai transports',
    validationErrors: 'Lūdzu, izlabojiet šādas kļūdas:',
    fieldRequired: 'Šis lauks ir obligāts',
    selectExitHub: 'Izvēlieties izejas mezglu',
    createExitHub: 'Izveidot izejas mezglu',
    backToRequests: 'Atpakaļ uz pieprasījumiem',
    noRequestsFound: 'Pieprasījumi nav atrasti',
    createFirstRequest: 'Lai sāktu, izveidojiet savu pirmo pieprasījumu',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Piedāvājumi',
    createOffer: 'Izveidot piedāvājumu',
    makeOffer: 'Iesniegt piedāvājumu',
    manageOffers: 'Pārvaldīt piedāvājumus',
    offerDetail: 'Piedāvājuma detaļas',
    offerId: 'Piedāvājuma ID',
    offeringNation: 'Piedāvātāja valsts',
    offerType: 'Piedāvājuma tips',
    treatment: 'Ārstēšana',
    transport: 'Transports',
    combined: 'Kombinēts',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ārstēšanas piedāvājums',
    transportOffer: 'Transporta piedāvājums',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Izvēlieties pacientus',
    selectedPatients: 'Izvēlētie pacienti',
    patientSelection: 'Pacientu atlase',
    offerConfiguration: 'Piedāvājuma konfigurācija',
    reviewOffer: 'Piedāvājuma pārskatīšana',
    submitOffer: 'Iesniegt piedāvājumu',
    submitting: 'Iesniegšana...',
    acceptOffer: 'Pieņemt piedāvājumu',
    rejectOffer: 'Noraidīt piedāvājumu',
    withdrawOffer: 'Atsaukt piedāvājumu',
    noOffers: 'Piedāvājumi nav pieejami',
    noOffer: 'No Offer',
    offerStatus: 'Piedāvājuma statuss',
    offerDate: 'Piedāvājuma datums',
    transportAsset: 'Transportlīdzeklis',
    departureDate: 'Izbraukšanas datums',
    arrivalDate: 'Ierašanās datums',
    treatmentFacility: 'Ārstniecības iestāde',
    capacity: 'Kapacitāte',
    availableCapacity: 'Pieejamā kapacitāte',
    totalCapacity: 'Kopējā kapacitāte',
    selectAsset: 'Izvēlieties līdzekli',
    selectFacility: 'Izvēlieties iestādi',
    offerNotes: 'Piedāvājuma piezīmes',
    confirmAccept: 'Vai tiešām vēlaties pieņemt šo piedāvājumu?',
    confirmReject: 'Vai tiešām vēlaties noraidīt šo piedāvājumu?',
    extendTransport: 'Paplašināts transports',
    transportExtension: 'Transporta paplašinājums',
    comparisonView: 'Salīdzinājuma skats',
    shortlist: 'Šaurais atlase',
    addToShortlist: 'Pievienot šaurajai atlasei',
    removeFromShortlist: 'Noņemt no šaurās atlases',
    leaveConfirmTitle: 'Atstāt lapu?',
    leaveConfirmMessage: 'Jums ir nesaglabātas izmaiņas. Vai tiešām vēlaties aiziet?',
    stayOnPage: 'Palikt lapā',
    leavePage: 'Atstāt lapu',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporti',
    missionDetail: 'Transporta detaļas',
    missionId: 'Transporta ID',
    missionStatus: 'Transporta statuss',
    createMission: 'Izveidot transportu',
    overview: 'Pārskats',
    patientsTab: 'Pacienti',
    transportsTab: 'Transporta posmi',
    treatmentTab: 'Ārstēšana',
    reviewTab: 'Pārskatīšana',
    departure: 'Izbraukšana',
    arrival: 'Ierašanās',
    origin: 'Sākumpunkts',
    destination: 'Galamērķis',
    stops: 'Pieturas',
    addStop: 'Pievienot pieturu',
    removeStop: 'Noņemt pieturu',
    stopName: 'Pieturas nosaukums',
    stopType: 'Pieturas tips',
    estimatedTime: 'Plānotais laiks',
    actualTime: 'Faktiskais laiks',
    asset: 'Līdzeklis',
    driver: 'Vadītājs',
    crew: 'Apkalpe',
    noMissions: 'Transporti nav atrasti',
    completeMission: 'Pabeigt transportu',
    cancelMission: 'Atcelt transportu',
    startTransport: 'Sākt transportu',
    missionChain: 'Transporta ķēde',
    linkedMissions: 'Saistītie transporti',
    handover: 'Nodošana',
    handoverPoint: 'Nodošanas punkts',
    pickupPoint: 'Uzņemšanas punkts',
    dropoffPoint: 'Nogādāšanas punkts',
    searchTransports: 'Meklēt transportus...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacienti',
    myPatients: 'Mani pacienti',
    patientId: 'Pacienta ID',
    firstName: 'Vārds',
    lastName: 'Uzvārds',
    dateOfBirth: 'Dzimšanas datums',
    age: 'Vecums',
    gender: 'Dzimums',
    male: 'Vīrietis',
    female: 'Sieviete',
    other: 'Cits',
    nationality: 'Pilsonība',
    diagnosis: 'Diagnoze',
    condition: 'Stāvoklis',
    stable: 'Stabils',
    critical: 'Kritisks',
    serious: 'Nopietns',
    treatmentNeeded: 'Nepieciešamā ārstēšana',
    allergies: 'Alerģijas',
    medications: 'Medikamenti',
    bloodType: 'Asins grupa',
    weight: 'Svars (kg)',
    infectious: 'Infekciozs',
    mentalHealth: 'Psihiskā veselība',
    mobility: 'Mobilitāte',
    ambulatory: 'Pārvietoties spējīgs',
    wheelchair: 'Ratiņkrēsls',
    stretcher: 'Nestuves',
    intensive: 'Intensīvā aprūpe',
    oxygenRequired: 'Nepieciešams skābeklis',
    ventilator: 'Ventilators',
    medicalEscort: 'Medicīniskais pavadonis',
    noPatients: 'Pacienti nav atrasti',
    patientDetails: 'Pacienta informācija',
    medicalHistory: 'Medicīniskā vēsture',
    travelDocuments: 'Ceļošanas dokumenti',
    passport: 'Pase',
    pseudonymizedId: 'Pseidonimizēts ID',
    sensitiveData: 'Sensitīvi dati',
    journey: 'Pacienta ceļš',
    assignedTo: 'Piešķirts',
    currentLocation: 'Pašreizējā atrašanās vieta',
    importPatients: 'Importēt pacientus',
    exportPatients: 'Eksportēt pacientus',
    seated: 'Sēdvietas',
    lying: 'Guļvietas',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Lietotāji',
    createUser: 'Izveidot lietotāju',
    editUser: 'Rediģēt lietotāju',
    deleteUser: 'Dzēst lietotāju',
    username: 'Lietotājvārds',
    displayName: 'Attēlotais vārds',
    email: 'E-pasts',
    password: 'Parole',
    role: 'Loma',
    roles: 'Lomas',
    nation: 'Valsts',
    active: 'Aktīvs',
    lastLogin: 'Pēdējā pieteikšanās',
    createdAt: 'Izveidots',
    isNation: 'Valsts',
    isEU: 'ES',
    isAdmin: 'Administrators',
    isExcon: 'EXCON',
    isPlanner: 'Plānotājs',
    isHub: 'Mezgls',
    isReadOnly: 'Tikai lasīšana',
    noUsers: 'Lietotāji nav atrasti',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo lietotāju?',
    resetPassword: 'Atiestatīt paroli',
    generatePassword: 'Ģenerēt paroli',
    searchUsers: 'Meklēt lietotājus...',
    userCreated: 'Lietotājs veiksmīgi izveidots',
    userUpdated: 'Lietotājs veiksmīgi atjaunināts',
    userDeleted: 'Lietotājs veiksmīgi dzēsts',
    selectNation: 'Izvēlieties valsti',
    mustChangePassword: 'Jāmaina parole nākamajā pieteikšanās reizē',
    flagImage: 'Karoga attēls',
    exportUsers: 'Eksportēt lietotājus',
    importUsers: 'Importēt lietotājus',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Līdzekļi',
    createAsset: 'Izveidot līdzekli',
    editAsset: 'Rediģēt līdzekli',
    deleteAsset: 'Dzēst līdzekli',
    assetName: 'Līdzekļa nosaukums',
    assetType: 'Līdzekļa tips',
    capacitySeated: 'Kapacitāte (sēdvietas)',
    capacityLying: 'Kapacitāte (guļvietas)',
    capacityIntensive: 'Kapacitāte (intensīvā aprūpe)',
    owner: 'Īpašnieks',
    operator: 'Operators',
    baseLocation: 'Bāzes atrašanās vieta',
    range: 'Darbības rādiuss',
    speed: 'Ātrums',
    noAssets: 'Līdzekļi nav atrasti',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo līdzekli?',
    searchAssets: 'Meklēt līdzekļus...',
    assetCreated: 'Līdzeklis veiksmīgi izveidots',
    assetUpdated: 'Līdzeklis veiksmīgi atjaunināts',
    assetDeleted: 'Līdzeklis veiksmīgi dzēsts',
    exportAssets: 'Eksportēt līdzekļus',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Mezglu punkti',
    startPoints: 'Sākuma punkti',
    createHub: 'Izveidot mezglu',
    editHub: 'Rediģēt mezglu',
    deleteHub: 'Dzēst mezglu',
    hubName: 'Mezgla nosaukums',
    hubType: 'Mezgla tips',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ieejas mezgls',
    airport: 'Lidosta',
    seaport: 'Osta',
    railStation: 'Dzelzceļa stacija',
    roadPoint: 'Ceļa punkts',
    ucpmClassification: 'UCPM klasifikācija',
    icaoCode: 'ICAO kods',
    iataCode: 'IATA kods',
    noHubs: 'Mezgli nav atrasti',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo mezglu?',
    searchHubs: 'Meklēt mezglus...',
    nationAssignment: 'Valstu piešķiršana',
    assignNations: 'Piešķirt valstis',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Ārstniecības iestādes',
    createFacility: 'Izveidot iestādi',
    editFacility: 'Rediģēt iestādi',
    deleteFacility: 'Dzēst iestādi',
    facilityName: 'Iestādes nosaukums',
    facilityType: 'Iestādes tips',
    hospitalName: 'Slimnīcas nosaukums',
    bedCapacity: 'Gultu kapacitāte',
    specialties: 'Specialitātes',
    availableBeds: 'Pieejamās gultas',
    totalBeds: 'Gultas kopā',
    contactPerson: 'Kontaktpersona',
    noFacilities: 'Ārstniecības iestādes nav atrastas',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo iestādi?',
    searchFacilities: 'Meklēt iestādes...',
    hubNationAssignment: 'Mezgla valstu piešķiršana',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Grafiki',
    createSchedule: 'Izveidot grafiku',
    editSchedule: 'Rediģēt grafiku',
    deleteSchedule: 'Dzēst grafiku',
    scheduleName: 'Grafika nosaukums',
    scheduleType: 'Grafika tips',
    recurring: 'Atkārtojošs',
    oneTime: 'Vienreizējs',
    frequency: 'Biežums',
    daily: 'Ikdienas',
    weekly: 'Iknedēļas',
    startDate: 'Sākuma datums',
    endDate: 'Beigu datums',
    departureTime: 'Izbraukšanas laiks',
    arrivalTime: 'Ierašanās laiks',
    stops: 'Pieturas',
    addStop: 'Pievienot pieturu',
    noSchedules: 'Grafiki nav atrasti',
    bookings: 'Rezervācijas',
    timeline: 'Laika grafiks',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Paziņojumi',
    markAllRead: 'Atzīmēt visus kā izlasītus',
    markAsRead: 'Atzīmēt kā izlasītu',
    markAsUnread: 'Atzīmēt kā neizlasītu',
    noNotifications: 'Paziņojumu nav',
    viewAll: 'Skatīt visus paziņojumus',
    settings: 'Paziņojumu iestatījumi',
    emailNotifications: 'E-pasta paziņojumi',
    inAppNotifications: 'Lietotnes paziņojumi',
    notifyOn: 'Paziņot man par',
    requestCreated: 'Jauns pieprasījums',
    requestPublished: 'Pieprasījums publicēts',
    requestClosed: 'Pieprasījums slēgts',
    requestCompleted: 'Pieprasījums pabeigts',
    commentAdded: 'Jauns komentārs',
    offerReceived: 'Piedāvājums saņemts',
    offerAccepted: 'Piedāvājums pieņemts',
    statusChanged: 'Statuss mainīts',
    selectionStarted: 'Atlase sākta',
    missionCreated: 'Transports izveidots',
    missionStatusUpdated: 'Transports atjaunināts',
    transportPartnerNamed: 'Transporta partneris',
    transportExtensionReceived: 'Transporta paplašinājums',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Iestatījumi',
    general: 'Vispārīgi',
    system: 'Sistēma',
    email: 'E-pasts',
    sync: 'Sinhronizācija',
    security: 'Drošība',
    appearance: 'Izskats',
    systemName: 'Sistēmas nosaukums',
    systemEmail: 'Sistēmas e-pasts',
    maintenanceMode: 'Apkopes režīms',
    readOnlyMode: 'Tikai lasīšanas režīms',
    emailEnabled: 'E-pasts iespējots',
    smtpHost: 'SMTP serveris',
    smtpPort: 'SMTP ports',
    smtpUser: 'SMTP lietotājs',
    smtpPassword: 'SMTP parole',
    senderEmail: 'Sūtītāja e-pasts',
    senderName: 'Sūtītāja vārds',
    testEmail: 'Nosūtīt testa e-pastu',
    syncEnabled: 'Sinhronizācija iespējota',
    syncUrl: 'Sinhronizācijas URL',
    syncApiKey: 'Sinhronizācijas API atslēga',
    settingsSaved: 'Iestatījumi veiksmīgi saglabāti',
    helpdesk: 'Palīdzības dienests',
    helpdeskTitle: 'Palīdzības dienesta nosaukums',
    helpdeskEmail: 'Palīdzības dienesta e-pasts',
    helpdeskPhone: 'Palīdzības dienesta tālrunis',
    helpdeskInfo: 'Palīdzības dienesta informācija',
    realLifeSupport: 'Reālās dzīves atbalsts',
    trainingMode: 'Apmācību režīms',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Audita žurnāls',
    action: 'Darbība',
    user: 'Lietotājs',
    target: 'Mērķis',
    details: 'Detaļas',
    timestamp: 'Laikspiedols',
    ipAddress: 'IP adrese',
    noLogs: 'Audita ieraksti nav atrasti',
    searchLogs: 'Meklēt ierakstos...',
    filterByAction: 'Filtrēt pēc darbības',
    filterByUser: 'Filtrēt pēc lietotāja',
    exportLogs: 'Eksportēt ierakstus',
    exportCsv: 'Eksportēt CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Mācību vadība',
    currentDay: 'Pašreizējā diena',
    exerciseDay: 'Mācību diena',
    nextDay: 'Nākamā diena',
    previousDay: 'Iepriekšējā diena',
    resetExercise: 'Atiestatīt mācības',
    startExercise: 'Sākt mācības',
    endExercise: 'Beigt mācības',
    dayReset: 'Dienas atiestatīšana',
    confirmReset: 'Vai tiešām vēlaties atiestatīt mācību dienu? Tiks dzēsti visi pašreizējās dienas dati.',
    resetInProgress: 'Atiestatīšana notiek...',
    maintenanceMode: 'Apkopes režīms',
    enableMaintenance: 'Iespējot apkopi',
    disableMaintenance: 'Atspējot apkopi',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datu sinhronizācija',
    syncStatus: 'Sinhronizācijas statuss',
    lastSync: 'Pēdējā sinhronizācija',
    pendingItems: 'Gaidošie ieraksti',
    syncNow: 'Sinhronizēt tagad',
    syncing: 'Sinhronizācija...',
    syncSuccess: 'Sinhronizācija veiksmīgi pabeigta',
    syncFailed: 'Sinhronizācija neizdevās',
    outbox: 'Izejošie',
    inbox: 'Ienākošie',
    configuration: 'Konfigurācija',
    targetUrl: 'Mērķa URL',
    apiKey: 'API atslēga',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Karte',
    layers: 'Slāņi',
    requests: 'Pieprasījumi',
    hubs: 'Mezgli',
    facilities: 'Iestādes',
    routes: 'Maršruti',
    showAll: 'Rādīt visus',
    hideAll: 'Paslēpt visus',
    zoomIn: 'Tuvināt',
    zoomOut: 'Tālināt',
    resetView: 'Atiestatīt skatu',
    satellite: 'Satelīts',
    terrain: 'Reljefs',
    offline: 'Bezsaistē',
    online: 'Tiešsaistē',
    tilesOffline: 'Kartes elementi tiek ielādēti lokāli',
    tilesOnline: 'Kartes elementi tiek ielādēti no tiešsaistes serveriem',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Pārskats',
    requestsByStatus: 'Pieprasījumi pēc statusa',
    requestsByCategory: 'Pieprasījumi pēc kategorijas',
    requestsByNation: 'Pieprasījumi pēc valsts',
    offersByStatus: 'Piedāvājumi pēc statusa',
    patientsByCondition: 'Pacienti pēc stāvokļa',
    transportsByStatus: 'Transporti pēc statusa',
    timeline: 'Laika grafiks',
    totalRequests: 'Pieprasījumi kopā',
    totalOffers: 'Piedāvājumi kopā',
    totalPatients: 'Pacienti kopā',
    totalTransports: 'Transporti kopā',
    averageResponseTime: 'Vidējais atbildes laiks',
    completionRate: 'Izpildes rādītājs',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Mācību statistika',
    overview: 'Pārskats',
    byCategory: 'Pēc kategorijas',
    byNation: 'Pēc valsts',
    byDay: 'Pēc dienas',
    totalPatientsMoved: 'Transportēti pacienti kopā',
    totalRequestsProcessed: 'Apstrādāti pieprasījumi kopā',
    averageProcessingTime: 'Vidējais apstrādes laiks',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Plūsmas diagramma',
    sankey: 'Sankey',
    nodeGraph: 'Mezglu grafiks',
    refresh: 'Atsvaidzināt',
    noData: 'Plūsmas dati nav pieejami',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Par sistēmu',
    version: 'Versija',
    systemInfo: 'Sistēmas informācija',
    buildDate: 'Izveides datums',
    environment: 'Vide',
    description: 'ARCOS — Uzlabota pieprasījumu komunikācijas sistēma',
    subtitle: 'Cietušo palīdzība un medicīniskās operācijas',
    whatIsArcos: 'Kas ir ARCOS? – Skaidrojums mācību dalībniekiem',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Atbalsta MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – kur zinātkāre satiek sadarbību.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentācija',
    gettingStarted: 'Darba sākšana',
    userGuide: 'Lietotāja rokasgrāmata',
    faq: 'Biežāk uzdotie jautājumi',
    troubleshooting: 'Problēmu novēršana',
    apiReference: 'API atsauce',
    downloadTemplate: 'Lejupielādēt veidni',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Pacientu imports',
    uploadFile: 'Augšupielādēt failu',
    selectFile: 'Izvēlēties failu',
    preview: 'Priekšskatījums',
    importNow: 'Importēt tagad',
    importing: 'Importēšana...',
    importSuccess: '{{count}} pacienti veiksmīgi importēti',
    importFailed: 'Imports neizdevās',
    downloadTemplate: 'Lejupielādēt veidni',
    dragDrop: 'Velciet un nometiet failu šeit vai noklikšķiniet, lai izvēlētos',
    supportedFormats: 'Atbalstītie formāti: XLSX, XLS, CSV',
    rowsFound: '{{count}} rindas atrastas',
    validRows: '{{count}} derīgas rindas',
    invalidRows: '{{count}} nederīgas rindas',
    duplicateRows: '{{count}} dublikāti',
    previewData: 'Datu priekšskatījums',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transporta plānošana',
    planRoute: 'Plānot maršrutu',
    routeBuilder: 'Maršruta veidotājs',
    addWaypoint: 'Pievienot pieturu',
    removeWaypoint: 'Noņemt pieturu',
    estimatedDuration: 'Plānotais ilgums',
    distance: 'Attālums',
    selectVehicle: 'Izvēlieties transportlīdzekli',
  },

  transportBooking: {
    title: 'Transporta rezervēšana',
    bookTransport: 'Rezervēt transportu',
    availableSlots: 'Pieejamās vietas',
    bookingConfirmed: 'Rezervācija apstiprināta',
    cancelBooking: 'Atcelt rezervāciju',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapacitātes plānošana',
    totalCapacity: 'Kopējā kapacitāte',
    usedCapacity: 'Izmantotā kapacitāte',
    availableCapacity: 'Pieejamā kapacitāte',
    utilizationRate: 'Izmantošanas rādītājs',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Līdzekļu veidnes',
    dayTemplates: 'Dienas veidnes',
    createTemplate: 'Izveidot veidni',
    editTemplate: 'Rediģēt veidni',
    deleteTemplate: 'Dzēst veidni',
    templateName: 'Veidnes nosaukums',
    applyTemplate: 'Lietot veidni',
    noTemplates: 'Veidnes nav atrastas',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo veidni?',
    confirmApply: 'Vai tiešām vēlaties lietot šo veidni? Tas pārrakstīs esošos datus.',
    exportTemplates: 'Eksportēt veidnes',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Paziņojumu josla',
    createAnnouncement: 'Izveidot paziņojumu',
    editAnnouncement: 'Rediģēt paziņojumu',
    deleteAnnouncement: 'Dzēst paziņojumu',
    message: 'Ziņojums',
    startTime: 'Sākuma laiks',
    endTime: 'Beigu laiks',
    active: 'Aktīvs',
    noAnnouncements: 'Paziņojumu nav',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo paziņojumu?',
  },

  // ============================================================
  // COMPONENTS — Atkārtoti lietojamu komponentu virknes
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Meklēt...',
      noResults: 'Rezultāti nav atrasti',
      showing: 'Rādīti {{from}} līdz {{to}} no {{total}}',
      rowsPerPage: 'Rindas lapā',
      previousPage: 'Iepriekšējā lapa',
      nextPage: 'Nākamā lapa',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Apstiprināt',
      cancel: 'Atcelt',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Nesaglabātas izmaiņas',
      message: 'Jums ir nesaglabātas izmaiņas. Vai tiešām vēlaties atstāt šo lapu?',
      stay: 'Palikt lapā',
      leave: 'Atstāt lapu',
    },
    // EmptyState
    emptyState: {
      noData: 'Dati nav pieejami',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Kaut kas nogāja greizi',
      message: 'Radās neparedzēta kļūda. Lūdzu, mēģiniet atsvaidzināt lapu.',
      retry: 'Mēģināt vēlreiz',
    },
    // ExportButton
    exportButton: {
      export: 'Eksportēt',
      exporting: 'Eksportēšana...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Drukāt',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Melnraksts',
      review: 'Pārskatīšana',
      published: 'Publicēts',
      selection: 'Atlase',
      inTransit: 'Ceļā',
      completed: 'Pabeigts',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Tiešsaistes instance',
      message: 'Tikai lasīšanas režīms. Dati tiek sinhronizēti no primārā servera.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Jūs skatāt kā',
      loggedInAs: 'pieteicies kā {{nation}}',
      returnTo: 'Atgriezties uz {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Meklēt lapas, pieprasījumus, transportus...',
      searching: 'Meklēšana...',
      noResults: 'Nav rezultātu vaicājumam "{{query}}"',
      navigate: 'Navigēt',
      select: 'Izvēlēties',
      close: 'Aizvērt',
      pages: {
        dashboard: 'Vadības panelis',
        requests: 'Pieprasījumi',
        transports: 'Transporti',
        map: 'Karte',
        myPatients: 'Mani pacienti',
        flowDiagram: 'Plūsmas diagramma',
        statistics: 'Statistika',
        assets: 'Līdzekļi',
        startPoints: 'Sākuma punkti / Mezgli',
        treatmentFacilities: 'Ārstniecības iestādes',
        users: 'Lietotāji',
        settings: 'Iestatījumi',
        auditLogs: 'Audita žurnāls',
        exerciseControl: 'Mācību vadība',
        dataSync: 'Datu sinhronizācija',
        patientImport: 'Pacientu imports',
        notifications: 'Paziņojumi',
        documentation: 'Dokumentācija',
      },
      actions: {
        importPatientsJson: 'Importēt Pacientus (JSON)',
        importPatientsExcel: 'Importēt Pacientus (Excel)',
        importUsers: 'Importēt Lietotājus (Excel)',
        importAssetTemplates: 'Importēt Līdzekļu veidnes (Excel)',
        importDayTemplates: 'Importēt Dienas veidnes ierakstus (Excel)',
        exportRequests: 'Eksportēt Pieprasījumus (Excel)',
        exportPatients: 'Eksportēt Pacientus (Excel)',
        exportUsers: 'Eksportēt Lietotājus (Excel)',
        exportCredentials: 'Eksportēt Akreditācijas dati (PDF)',
        exportAuditExcel: 'Eksportēt Audita žurnāls (Excel)',
        exportAuditPdf: 'Eksportēt Audita žurnāls (PDF)',
        pagePatientImport: 'Pacientu importa lapa',
        pageRequestDetail: 'Pieprasījuma detaļu lapa',
        pageUsers: 'Lietotāju pārvaldības lapa',
        pageAssetTemplates: 'Līdzekļu veidņu lapa',
        pageDayTemplates: 'Dienas veidņu lapa',
        pageRequests: 'Pieprasījumu saraksta lapa',
        pageAuditLogs: 'Audita žurnāla lapa',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesija beidzas',
      message: 'Jūsu sesija beigsies pēc <strong>{{time}}</strong>. Lūdzu, saglabājiet savu darbu un pieteikieties atkārtoti, lai turpinātu.',
      dismiss: 'Noraidīt',
      logoutNow: 'Izrakstīties tagad',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Izvēlieties 4 laika joslas',
      configure: 'Konfigurēt laika joslas',
      reset: 'Atiestatīt',
      apply: 'Lietot',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Izvēlieties atrašanās vietu',
      latitude: 'Platuma grāds',
      longitude: 'Garuma grāds',
      clickToSelect: 'Noklikšķiniet uz kartes, lai izvēlētos atrašanās vietu',
    },
    // Modal
    modal: {
      close: 'Aizvērt',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Sākumlapa',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Sistēmas apkope',
    message: 'Sistēma tiek atiestatīta nākamajai mācību dienai. Lūdzu, uzgaidiet, kamēr process tiek pabeigts.',
    autoRefresh: 'Šī lapa automātiski atsvaidzināsies, kad sistēma būs atkal pieejama.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Vismaz 10 rakstzīmes',
    uppercase: '1 lielais burts',
    lowercase: '1 mazais burts',
    digit: '1 cipars',
    special: '1 speciālā rakstzīme',
  },
};

export default lv;
